import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Renderer2,
  ElementRef,
  TemplateRef,
  ViewContainerRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  AfterViewInit,
} from '@angular/core';
import { merge, fromEvent, Observable, Subject } from 'rxjs';
import { debounceTime, map, switchMap, takeUntil } from 'rxjs/operators';
import { Project, ProjectPagination } from 'app/modules/projects/projects.types';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { UserService } from 'app/layout/common/user/user.service';
import { AccountService } from 'app/core';
import { Account, FieldDef } from 'app/core/models/account.types';

@Component({
  selector: 'shared-resources-project-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedResourcesProjectDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
  project: Project;
  account: Account;

  private _unsubscribeAll: Subject<void>;

  panels = [
    [
      {
        type: 'form',
        title: 'Main Info',
        meta: {},
      },
      {
        type: 'images',
        title: 'Gallery',
        meta: {},
      },
    ],
    [
      {
        type: 'tasks',
        title: 'Tasks',
        meta: {},
      },
      {
        type: 'files',
        title: 'Recent Files',
        meta: {},
      },
      {
        type: 'notes',
        title: 'Notes',
        meta: {},
      },
    ],
    [
      {
        type: 'map',
        title: 'Locations',
        meta: {},
      },

      {
        type: 'form',
        title: 'Deal Overview',
        meta: {},
      },
    ],
  ];

  /**
   * Constructor
   */
  constructor(private _userService: UserService, private _changeDetectorRef: ChangeDetectorRef) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions

    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
